import { _ } from "../../core/polyglot/polyglot.js";
import accountingDocument from "../shared/accountingDocument.js";
import optionsBag from "../../models/options/optionsBag.js";

/**
 * `invoiceReportArchiveDocument` displays all available invoice-related reports
 * (accounts payable and receivable).
 */
const invoiceReportArchiveDocument = accountingDocument.subclass((that, my) => {
	my.initialize = function () {
		my.super(...arguments);

		that.title = _("Accounts pay/rec archive");
		that.subtitle = _("All accounts payable & receivable reports");
		that.documentId = "invoice-report-archive";

		that.help = {
			summary: _(
				"This archive includes all accounts payable and accounts receivable reports.",
			),
			sections: [
				{
					title: _("Accounts payable"),
					content: (html) => {
						html.p(
							_(
								"This report lists the open accounts payable from the last import date.",
							),
						);
					},
				},
				{
					title: _("Accounts receivable"),
					content: (html) => {
						html.p(
							_(
								"This report lists the open accounts payable from the last import date.",
							),
						);
					},
				},
				{
					title: _("Aged payables"),
					content: (html) => {
						html.p(
							_(
								"This report distinguishes open accounts payable based on the duration an invoice has been outstanding.",
							),
						);
					},
				},
				{
					title: _("Aged receivables"),
					content: (html) => {
						html.p(
							_(
								"This report distinguishes open accounts receivable based on the duration an invoice has been outstanding.",
							),
						);
					},
				},
			],
		};
	};

	that.hasPeriodPicker = function () {
		return false;
	};

	that.hasActionsMenu = function () {
		return false;
	};

	that.show = function () {
		that.showContent();
	};

	my.renderContentOn = function (html) {
		html.render(
			my.section({
				cssClass: "invoice-report-archive-section",
				content: my.renderReportsOn,
			}),
		);
	};

	my.renderReportsOn = function (html) {
		html.render(
			my.reportIconRenderer({
				route: "accounts-payable-report",
				label: _("Accounts payable"),
				enabled: my.hasInvoiceReportsEnabled(),
			}),
			my.reportIconRenderer({
				route: "accounts-receivable-report",
				label: _("Accounts receivable"),
				enabled: my.hasInvoiceReportsEnabled(),
			}),
			my.reportIconRenderer({
				route: "aged-payables-per-supplier",
				label: _("Aged payables"),
				enabled: my.hasAgedInvoiceReportsEnabled(),
			}),
			my.reportIconRenderer({
				route: "aged-receivables-per-customer",
				label: _("Aged receivables"),
				enabled: my.hasAgedInvoiceReportsEnabled(),
			}),
		);
	};

	my.reportIconRenderer = function ({ route, label, enabled = true }) {
		return (html) => {
			if (!enabled) {
				return;
			}

			html.a(
				{ klass: "folder", href: my.linkTo(route) },
				html.div(
					{
						klass: "icon",
					},
					html.img({ src: "/Client/img/fp-icon-invoice-report.png" }),
				),
				html.p(label),
			);
		};
	};

	my.hasAgedInvoiceReportsEnabled = function () {
		return optionsBag.fromId("aged-invoice-reports").isActive();
	};

	my.hasInvoiceReportsEnabled = function () {
		optionsBag.fromId("invoice").isActive();
	};
});

export default invoiceReportArchiveDocument;
